import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';

// "My Profile" nav → resolve the login to its `people` record and open /people/{id}.
export default function MyProfileRedirect() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState('loading');

  useEffect(() => {
    if (!user) return;
    const email = (user.email || '').toLowerCase();
    const name = (user.name || '').toLowerCase();
    const q = user.role === 'ceo' ? '' : `division_id=${user.division_id}&`;
    api.get(`/people?${q}include_inactive=true`).then(r => {
      const people = r.data || [];
      const match = people.find(p => [p.work_email, p.personal_email, p.email_personal, p.email].some(e => (e || '').toLowerCase() === email))
        || people.find(p => (p.name || '').toLowerCase() === name);
      if (match) navigate(`/people/${match.id}`, { replace: true });
      else setState('missing');
    }).catch(() => setState('missing'));
  }, [user, navigate]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-16 text-center" data-testid="my-profile-redirect">
      {state === 'loading' ? (
        <p className="text-sm" style={{ color: '#6B7280' }}>Opening your profile…</p>
      ) : (
        <div className="rounded-xl border bg-white p-6" style={{ borderColor: '#E5E1DC' }}>
          <h2 className="text-lg font-bold" style={{ color: '#1B2A4A' }}>No staff record linked to your login yet</h2>
          <p className="text-sm mt-2" style={{ color: '#6B7280' }}>Add yourself in HR Hub → People (use <b>{user?.email}</b> as the work email) and this link will open your profile automatically.</p>
          <button onClick={() => navigate('/people')} className="mt-4 px-4 py-2 rounded-md text-sm font-medium text-white" style={{ backgroundColor: '#1B2A4A' }} data-testid="goto-hr-hub-btn">Open HR Hub</button>
        </div>
      )}
    </div>
  );
}
